var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "p-5" },
      [
        _c("el-input", {
          attrs: { placeholder: "输入关键字进行过滤" },
          model: {
            value: _vm.filterText,
            callback: function ($$v) {
              _vm.filterText = $$v
            },
            expression: "filterText",
          },
        }),
        _vm._v(" "),
        _c("el-tree", {
          ref: "tree",
          staticClass: "filter-tree",
          attrs: {
            data: _vm.permissionMenu,
            props: _vm.defaultProps,
            "default-expand-all": "",
            "filter-node-method": _vm.filterNode,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }